import { FREQUENCY } from '../../models/DonationFrequency';
import { AMOUNT_INPUT } from '../../models/DonationAmount';

// * App Defaults
export const DEFAULT_HEADING_CONTENT = 'Make an impact today!';
export const DEFAULT_TAX_DEDUCTIBLE_MESSAGE = '{{ Non-profit name }} is a 501(c)3 tax-exempt organization and your donation is tax deductible within the guidelines of U.S. law. To claim a donation as a deduction on your U.S. taxes, please keep your donation receipt as your official record. We’ll email it to you after your donation is complete.';
export const DEFAULT_FREQUENCIES = [{
  name: FREQUENCY.ONE_TIME,
  isVisible: true,
  isDefault: true
}, {
  name: FREQUENCY.DAILY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.WEEKLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.BI_WEEKLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.MONTHLY,
  isVisible: true,
  isDefault: false
}, {
  name: FREQUENCY.QUARTERLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.SEMI_ANNUALLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.YEARLY,
  isVisible: false,
  isDefault: false
}];
export const DEFAULT_ONE_TIME_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 500,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 100,
  isVisible: true,
  isDefault: true
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 50,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_4,
  amount: 25,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];
export const DEFAULT_RECURRING_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 50,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 25,
  isVisible: true,
  isDefault: true
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 10,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_4,
  amount: 5,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];

/**
 * One-time amounts are hardcoded per CL-49020
 * Per product requirements, no amounts are set as default.
 */
export const DEFAULT_INTELLIGENT_ASK_ONE_TIME_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 25,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 50,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 100,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_4,
  amount: 500,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];

/**
 * Recurring amounts are hardcoded per CL-34460, and do not match DEFAULT_RECURRING_AMOUNTS.
 * Per product requirements, no amounts are set as default.
 */
export const DEFAULT_INTELLIGENT_ASK_RECURRING_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 25,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 45,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 70,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_4,
  amount: 90,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];